<script setup lang="ts">
import Product from "@/models/Product";
import SafeHtml from "@/components/utils/SafeHtml.vue";
import { formatPrice } from "@/utils/pricing";
import DiscountIcon from "@/components/icons/DiscountIcon.vue";

defineProps<{ product: Product }>();

const itemClasses = "d-flex flex-column align-items-center justify-content-end";
const textClasses =
  "d-flex flex-column align-items-center justify-content-center lh-1";
</script>
<template>
  <ul
    class="product-card-promotion-list d-flex border border-light-subtle p-0 m-0 align-self-center"
  >
    <li
      v-if="product.wallet_promotion_amount > 0"
      :class="itemClasses"
      @click.prevent
    >
      <i class="icon bi bi-credit-card text-success"></i>
      <p :class="textClasses">
        <safe-html
          tag="span"
          :html="formatPrice(product.wallet_promotion_amount)"
          class="highlight-text"
        />
        <span>Monedero</span>
      </p>
    </li>
    <li v-if="product.hasDiscount()" :class="itemClasses" @click.prevent>
      <i class="icon bi bi-tag text-danger"></i>
      <p :class="textClasses">
        <span class="highlight-text"
          >-{{ product.getPercentDiscountText() }}</span
        >
        <span>Oferta</span>
        <span>Descuento</span>
      </p>
    </li>
    <li
      v-if="product.has_shipping_promotion"
      :class="itemClasses"
      @click.prevent
    >
      <i class="icon bi bi-truck"></i>
      <p :class="textClasses">
        <span>Envío</span>
        <span>Gratis</span>
        <span><span class="highlight-text">3-5</span> días</span>
      </p>
    </li>
    <li v-if="product.coupon" :class="itemClasses" @click.prevent>
      <discount-icon class="icon" />
      <p :class="textClasses">
        <span>Aplica</span>
        <span class="highlight-text">Cupón</span>
      </p>
    </li>
    <li v-if="product.has_last_stock" :class="itemClasses" @click.prevent>
      <i class="icon bi bi-fire text-fire"></i>
      <p :class="textClasses">
        <span>Últimas</span>
        <span class="highlight-text">Piezas</span>
      </p>
    </li>
  </ul>
</template>
<style lang="scss" scoped>
@import "@/scss/variables.scss";

.product-card-promotion-list {
  list-style-type: none;
  li {
    width: 54px;
    height: 40px;
    overflow: hidden;
    position: relative;
    .icon {
      font-size: $font-size-base * 1.25;
      align-self: center;
      color: var(--bs-gray-600);
      margin: auto;
      transform-origin: 50% 0%;
    }
    p {
      color: var(--bs-gray-700);
      position: absolute;
      margin: 0;
      font-size: $font-size-base * 0.675;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      transform: scale(0);
      transform-origin: 50% 100%;
      .highlight-text {
        font-weight: bold;
        font-size: $font-size-base * 0.775;
      }
    }
    &:hover {
      .icon {
        transition:
          opacity 0.3s,
          transform 0.3s;
        opacity: 0;
        transform: scale(0);
      }
      p {
        transition:
          opacity 0.3s,
          transform 0.3s;
        opacity: 1;
        transform: scale(1);
      }
    }
  }
}
</style>
